<h2>Forgot Password</h2>
<div class="col-md-12" style="height:70%;">
  <div class="row col-md-12 "  [hidden]="HideForgotPasswordForm">
    <div class="col-md-1"></div>
    <div class="col-md-10">
      <input type="email" id="userEmail" class="w-100" placeholder="Email Address" [(ngModel)]="ForgotEmail" required />
    </div>
    <div class="col-md-1"></div>
  </div>
  <div class="col-md-12" [hidden]="!HideForgotPasswordForm">
    <span>If a User exists with that email address then an e-mail will be sent to it with instructions on how to reset their password.</span>
  </div>
  <div class="row col-md-12" style="margin-top:50px;">
    <div class="padding-5 col-md-6">
      <button class="blue cancel" (click)="CancelForgotPassword()">Cancel</button>
    </div>
    <div class="padding-5 col-md-6" style="text-align:right;" [hidden]="HideForgotPasswordForm">
      <button [disabled]="ForgotEmail.length == 0" class="blue continue" (click)="SendForgotPassword()">Submit</button>
    </div>
  </div>
</div>

